import { compose, toLower } from 'ramda';

import { ascii, trim, replace } from 'yafrpl/strings';

export const formatId = compose(toLower, replace(/\W/g, ''), ascii, trim);
